// removed by extract-text-webpack-plugin
module.exports = {"picker":"sB5G8urV_yzB4p8PmGsnH","row":"_1f1GZTpXfawPOfvfXEO55f"};


//////////////////
// WEBPACK FOOTER
// ./app/components/MultiPicker/style.scss
// module id = 1047
// module chunks = 0